
import { scrollTo } from '../../../application/typescript/utils/utils';

class BtnScroll {
  constructor() {
    this._init();
  }

  _init() {
    const buttons = document.querySelectorAll<HTMLButtonElement>('[data-scroll-next]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextSection = button.closest('section')?.nextElementSibling;
        if (nextSection) {
          scrollTo(nextSection)
        }
      });
    });
  }
}

export const btnScroll = new BtnScroll();
